var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmpoulebleu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.5H4.5M24.5 2V4.38889M44.5 23.5H47M8.5 8.21111L10.25 9.88333M40.5 8.21111L38.75 9.88333M18.75 35.4444H30.25M17 33.0556C14.9012 31.5514 13.3508 29.4543 12.5686 27.0614C11.7863 24.6685 11.8118 22.1011 12.6415 19.7228C13.4711 17.3446 15.0628 15.276 17.1911 13.8102C19.3194 12.3443 21.8765 11.5556 24.5 11.5556C27.1235 11.5556 29.6806 12.3443 31.8089 13.8102C33.9372 15.276 35.5289 17.3446 36.3585 19.7228C37.1882 22.1011 37.2137 24.6685 36.4314 27.0614C35.6492 29.4543 34.0988 31.5514 32 33.0556C31.0239 33.9788 30.289 35.1087 29.8547 36.3537C29.4204 37.5987 29.2989 38.924 29.5 40.2222C29.5 41.4894 28.9732 42.7046 28.0355 43.6006C27.0979 44.4966 25.8261 45 24.5 45C23.1739 45 21.9021 44.4966 20.9645 43.6006C20.0268 42.7046 19.5 41.4894 19.5 40.2222C19.7011 38.924 19.5796 37.5987 19.1453 36.3537C18.711 35.1087 17.9761 33.9788 17 33.0556Z",
    stroke: "#003F6D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpoulebleu1);
export default __webpack_public_path__ + "static/media/Ampoule bleu1.f36bcb0c4b8b53d677fa7744b10911d7.svg";
export { ForwardRef as ReactComponent };